export const clippedText = (
  text: string,
  chars: number,
  ellipses: string = "…",
) => {
  if (text.length > chars) {
    return text.slice(0, chars) + ellipses;
  } else {
    return text;
  }
};

export const appendComma = (text: string | null) => {
  if (text) return text + ", ";
  return "";
};
